<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="updateSubscription"
    >
      <header class="m-the-modal-header">
        <h5> Deseas cancelar tu suscripción! </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionAssetSendingOfDeliverablesModalCreate.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsModalCancelSubscription',

  data () {
    return {
      buttonPrimary: {
        action: 'Confirmar',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  methods: {
    updateSubscription () {
      this.buttonPrimary.sending = true
      this.$services.update('ventas', 'updateSubscription', null, [this.$modal.element.venta.suscripcion_activa])
        .then(response => {
          this.suscripcion = response.data
          this.$modal.updateData()
          if (this.$modal.element.venta.medio_pago === 'Transferencia Bancaria' || this.$modal.element.venta.medio_pago === 'WesternUnion') {
            this.$alerts.pushAlert('mEditionBillingMyPaymentsCancelSubscription', 'updateSubscription', 'success')
          } else {
            this.$alerts.pushAlert('mEditionBillingMyPaymentsCancelSubscription', 'updateSubscription', 'successGateway')
          }
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionBillingMyPaymentsCancelSubscription', 'updateSubscription', 'error', 'a-alert-danger')
          this.buttonPrimary.sending = false
          this.$modal.closeModal()
        })
    }
  }
}
</script>
